(() => {
  angular
    .module('gm.common.services')
    .factory('GmyImportExport', GmyImportExport);

  function GmyImportExport(
    gmApi,
    GmyToken,
    Upload
  ) {
    'ngInject';

    return {
      getExportUrl,
      uploadImport,
    };

    function getExportUrl(path) {
      return `${gmApi.getApiBasePath()}${path}`;
    }

    function uploadImport(url, file) {
      return Upload.upload({
        file,
        url: `${gmApi.getApiBasePath()}${url}`,
        method: 'PUT',
        headers: { 'X-Auth-Token': GmyToken.getToken() }
      });
    }
  }
})();
